import { Service, inject } from '@angular/core'
import { AppService } from '../../../app.service'

/** Gives shared services the mobile theme without changing the document classes. */
@Service()
export class MobileThemeService {
  private readonly appService = inject(AppService)
  readonly isDarkMode = this.appService.darkMode.asReadonly()
}
